"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleContent = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var config_context_1 = require("../_util/config-context");
var icon_1 = (0, tslib_1.__importDefault)(require("../icon"));
// 三角朝向和 placement 位置是相对的
var POSITION_MAP = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
};
exports.BubbleContent = (0, react_1.forwardRef)(function (props, ref) {
    var _a;
    var _b = props.placement, placement = _b === void 0 ? 'top' : _b, children = props.children, className = props.className, error = props.error, dark = props.dark, tooltip = props.tooltip, width = props.width, bubbleTitle = props.bubbleTitle, _c = props.loading, loading = _c === void 0 ? false : _c, bannerImg = props.bannerImg, htmlProps = (0, tslib_1.__rest)(props, ["placement", "children", "className", "error", "dark", "tooltip", "width", "bubbleTitle", "loading", "bannerImg"]);
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    // placement 可能是 "top-start" 的形式，需要拆成两个词来使用
    var _d = (0, tslib_1.__read)(placement.split('-'), 2), basePlacement = _d[0], placementModifier = _d[1]; // eslint-disable-line prefer-const
    if (basePlacement === 'auto') {
        basePlacement = 'top';
    }
    var focusPosition = POSITION_MAP[basePlacement] || 'bottom';
    if (width) {
        htmlProps.style = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, htmlProps === null || htmlProps === void 0 ? void 0 : htmlProps.style), { width: "" + (isNaN(+width) ? width : width + "px") });
    }
    if (tooltip) {
        return (react_1.default.createElement("div", (0, tslib_1.__assign)({ className: classPrefix + "-tooltip", ref: ref }, htmlProps),
            react_1.default.createElement("div", { className: classPrefix + "-tooltip__inner" }, children)));
    }
    return (react_1.default.createElement("div", (0, tslib_1.__assign)({ ref: ref, className: (0, classnames_1.default)((_a = {},
            _a[classPrefix + "-bubble"] = true,
            _a[classPrefix + "-bubble--" + focusPosition] = focusPosition,
            _a[classPrefix + "-bubble--" + placementModifier] = placementModifier,
            _a[classPrefix + "-bubble--error"] = error,
            _a[classPrefix + "-bubble--reverse"] = dark,
            _a[classPrefix + "-curr--img"] = bannerImg,
            _a[className] = className,
            _a)) }, htmlProps),
        react_1.default.createElement("div", { className: classPrefix + "-bubble__inner" }, loading
            ? (react_1.default.createElement(icon_1.default, { type: "loading" }))
            : (react_1.default.createElement(react_1.default.Fragment, null,
                bannerImg && (react_1.default.createElement("img", { src: bannerImg })),
                bubbleTitle && (react_1.default.createElement("div", { className: classPrefix + "-bubble__title" }, bubbleTitle)),
                bannerImg && react_1.default.createElement("div", { className: classPrefix + "-bubble__inner__limit" }, children),
                !bannerImg && children)))));
});
exports.BubbleContent.displayName = 'BubbleContent';
